import Settings from './components/Settings';
import reducer, { SettingsState } from './reducers';
import selectors from './selectors';
import operations from './operations';

export default reducer;
export {
  operations,
  selectors,
  Settings,
};
export type {
  SettingsState,
};
